export function phoneStartWithIndicative(internationalPrefix: string, phone: string = ""): boolean {
	const prefixNumber = internationalPrefix.replace("+", "");
	return phone.startsWith(prefixNumber);
}
